import React from 'react';
import { useSelector } from 'react-redux';
import { isDesktop } from '../../../common/helpers/utility/screenHelper';
import searchResource from '../../../locales/th/search.json';
import { WholeState as CommonState } from '../../../store/common/type';
import SelectInput from './SelectInput';
import { getPropertyTypeInputOptions } from '../propertyTypesUtil';
import { PropertyType } from '../../../common/helpers/domain/propertyTypes';

interface Props {
  onChange: (propertyKey: PropertyType) => void;
  currentProperty: PropertyType | 'any';
}

const PropertyTypeInputFilter: React.FC<Props> = ({
  onChange,
  currentProperty,
}) => {
  const deviceType = useSelector<CommonState, string>((state) =>
    state.common ? state.common.deviceType : 'desktop',
  );

  const options = getPropertyTypeInputOptions();
  options.unshift({
    key: 'any',
    name: searchResource.searchFilter.anyProperTypeDropdown,
  });
  return (
    <SelectInput
      options={options}
      labelText={searchResource.searchFilter.propertyType}
      selectedOptionKey={currentProperty}
      onSelect={(propertyType) => {
        if (propertyType === 'any') {
          onChange(undefined);
        } else {
          onChange(propertyType as PropertyType);
        }
      }}
      qaHook={'property-type'}
      isMobile={!isDesktop(deviceType)}
    />
  );
};

export default PropertyTypeInputFilter;
